export default {
  Login: '登入',
  Sign_up: '註冊',
  Feedback: '意見回饋',
  Settings: '設定',
  Log_out: '登出',
  mo: '月',
  Total: '總計',
  header: {
    download: '下載 iOS App / 擴充功能'
  }

}
